export const prefetchData = () => {};
